import PropTypes from "prop-types"
import DialogTitle from "@mui/material/DialogTitle"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import { Box, styled } from "@mui/material"

const StyledDialogTitle = styled(DialogTitle)(() => ({
  flexGrow: 1,
  wordBreak: "break-word",
}))

const DialogHeader = ({ children, onClose }) => (
  <Box display="flex" alignItems="center" justifyContent="space-between">
    <StyledDialogTitle data-test-id="dialogTitle">{children}</StyledDialogTitle>
    {onClose && (
      <IconButton sx={{ margin: "5px 10px 0" }} onClick={onClose} size="large" data-test-id="CloseIcon">
        <CloseIcon />
      </IconButton>
    )}
  </Box>
)

DialogHeader.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
}

DialogHeader.defaultProps = {
  onClose: null,
}

export default DialogHeader
